import { h, Component } from 'preact';
import { getStockPrice } from '@os/cloudquote';
import { Text } from 'preact-i18n';
import style from './style';
export class CurrencyIndicator extends Component {

	componentWillMount() {
		// Fetch the price data for the symbol
		getStockPrice(this.props.symbol).then((data) => {
			this.setState({ data });
		});
	}

	render({ symbol }, { data }) {
		let priceData = data && data.rows && data.rows[0] || undefined,
			code = 'USD';
		// Default to USD if no data available, otherwise use the provided code
		if (priceData && priceData.NominalCurrencyCode) {
			code = priceData.NominalCurrencyCode;
		}

		return (
			<span class={style['currency-indicator']}><Text id="currency-indicator" fields={{ code }} /></span>
		);
	}
}
